// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__3c94P","location":"Header_location__2VMPH"};